import SearchMobileRecap from '@ui/Search/MobileRecap/component'

export default (): void => {
  const searchMobileRecapEl = document.querySelector<HTMLElement>('.top-banner__search .search-mobile-recap')
  searchMobileRecapEl && SearchMobileRecap(searchMobileRecapEl)
}
